import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import {
  addContactRole, addContactRoles, changeContactRole, deleteContactRole
} from 'bundles/apex/deals/show/store/deal/actions';

import Card from 'bundles/apex/card';
import ContactFormModal from 'bundles/apex/deals/show/contacts/contact/contact_form_modal';
import GenericContactsPanel from 'bundles/backoffice/contacts/panel';

const DealContactsPanel = GenericContactsPanel({ ContactFormModal, Container: Card });

export function ContactsCard({ deleteContactRole, features, required, title, ...props }) {
  return (
    <DealContactsPanel
      allowTagging={features.crmTags}
      askForEmployer={features.contactsV2}
      confirmDeletion
      confirmSharedAttributes={features.edgeCrm}
      containerProps={{ className: 'contacts-card', label: title, required }}
      deleteContactRole={deleteContactRole}
      multipleBusinesses={features.contactsV2}
      parentLabel="Deal"
      renderLinks={features.edgeCrm}
      showEmployer={!features.contactsV2}
      {...props}
    />
  );
}

ContactsCard.propTypes = {
  deleteContactRole: PropTypes.func.isRequired,
  features: PropTypes.shape({
    contactsV2: PropTypes.bool,
    crmTags: PropTypes.bool,
    edgeCrm: PropTypes.bool,
  }).isRequired,
  required: PropTypes.bool,
  title: PropTypes.string,
};

const mapStateToProps = state => ({
  contactRoles: state.deal.contactRoles,
  features: state.features,
});

const mapDispatchToProps = {
  addContactRole,
  addContactRoles,
  changeContactRole,
  deleteContactRole
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactsCard);
